function Loading(config, renderer) {

  this.init = function () {
    return {};
  }

  this.done = function () {
    new UserInfoHeader(renderer).show(session)

    $.post('/load-pension')
      .fail(function() {
        $('#loading-failed').collapse('show')
        setTimeout(function() {
          location.href = '/'
        }, 1500)
      })
      .done(function (result) {
        session.setPension(new Pension(result.pension))
        session.setCustomer(result.customer)
        session.showLoginDisclaimer = result.showLoginDisclaimer
        $('#page').fadeOut(function() {
          location.href = '#overview?fade=in'
        })
    })
  }
}